import { registerReducer } from '../reducers'

const modules = {}

const module = store => (name, moduleProvider) => {
	if (modules.hasOwnProperty(name)) {
		return modules[name]
	} else {
		registerReducer(store, name, moduleProvider.Reducer)
		return moduleProvider.Reducer
	}
}

export default module
